import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class GraphService {
  constructor(private readonly msalService: MsalService) {}

  private async getAccessToken(
    scopes: string[] = ['User.Read'],
  ): Promise<string> {
    const account = this.msalService.instance.getAllAccounts()[0];
    if (!account) throw new Error('No signed-in account');

    try {
      const silentResult = await this.msalService.instance.acquireTokenSilent({
        scopes,
        account,
      });
      return silentResult.accessToken;
    } catch {
      // fallback to interactive if silent fails
      const popupResult = await this.msalService.instance.acquireTokenPopup({
        scopes,
      });
      return popupResult.accessToken;
    }
  }

  // returns a Blob or throws
  async getUserPhotoBlob(userId?: string): Promise<Blob> {
    const scope = ['User.Read']; // or User.Read.All if configured and consented
    const token = await this.getAccessToken(scope);
    const url = userId
      ? `https://graph.microsoft.com/v1.0/users/${encodeURIComponent(userId)}/photo/$value`
      : `https://graph.microsoft.com/v1.0/me/photo/$value`;

    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.status === 404) throw new Error('No photo');
    if (!res.ok) throw new Error(`Graph error ${res.status}`);

    const blob = await res.blob();
    return blob;
  }
}
